export default "__VITE_ASSET__99cd0a54__"